import { Component, Input, OnInit, inject } from '@angular/core';
import { UINotificationActions } from '../+state/notifications/notification.actions';
import { NotificationsState, SphereNotification } from '../+state/notifications/notification.reducer';
import { NotificationHelperService } from './notification-helper.service';
import { Store } from '@ngrx/store';
import { timer } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { formatDate, UpperCasePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatAnchor } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { MatProgressBar } from '@angular/material/progress-bar';
import { PulsingIndicatorComponent } from '../../components/pulsing-indicator/pulsing-indicator.component';

// TODO: Pending move from core to platform.
// import { SphereDateService } from 'core/settings/helpers/sphere-date.service';

@Component({
    selector: `sphere-shell-notification`,
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    imports: [MatIcon, MatAnchor, RouterLink, MatProgressBar, PulsingIndicatorComponent, UpperCasePipe]
})
export class NotificationComponent implements OnInit {
    private store = inject<Store<NotificationsState>>(Store);
    private helper = inject(NotificationHelperService);

    @Input() notification!: SphereNotification;

    ngOnInit() {
        let milliseconds = 5000;
        if (this.notification?.autoDismiss && this.notification.autoDismiss > 0) {
            milliseconds = this.notification.autoDismiss * 1000;
        }
        timer(milliseconds || 8000)
            .pipe(
                take(1),
                tap(() => this.dismissVisible())
            )
            .subscribe();
    }

    dismissVisible() {
        this.store.dispatch(UINotificationActions.dismissVisibleNotification({ id: this.notification.id }));
    }

    markAsRead() {
        this.store.dispatch(UINotificationActions.markNotificationAsRead({ id: this.notification.id }));
        this.store.dispatch(UINotificationActions.markNotificationAsNotNew({ id: this.notification.id }));
    }

    formatTimestamp(date: Date): string {
        // return this.date.format(date, 'time');
        // TODO: Temporary solution to avoid loading settings into portal shell.
        return formatDate(date, 'shortTime', 'en-US');
    }

    get contextIcon(): string {
        return this.helper.getContextIcon(this.notification.context);
    }

    get contextClass(): string {
        return this.helper.getContextClass(this.notification.context);
    }

    get isInProgress(): boolean {
        return this.helper.isInProgress(this.notification.context);
    }
}
